import React, {useEffect, useContext, useState} from 'react';

import {
  Modal,
  Form,
  Dimmer,
  Loader,
  Dropdown,
  ModalHeader,
  ModalActions,
  Progress,
  Button,
  FormInput,
  TextArea,
} from 'semantic-ui-react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import ContactInput from '../../components/ContactInput';
import { parsePhoneNumber } from 'react-phone-number-input';

import { sendInvite } from '../../../services/Invite';
import { toast } from 'react-toastify';

import {createAddressBookContact,enableInboundCalling} from '../../../services/messageRecipients'
import RedirectContext from '../../../contexts/RedirectContext';


const AddContactModal = ({isModalOpen, close, residentId, reload}) => {
  const [contact, setContact] = useState();
  const [error, setError] = useState('');
  const [usernameError, setUsernameError] = useState('');

  const [makingCalls, setMakingCalls] = useState(false);
  const [makingCallsPercent, setMakingCallsPercent] = useState(0);

  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const toggleRedirect = useContext(RedirectContext);



  const wait = async seconds => {
    return new Promise((resolve) => {
      setTimeout(resolve, seconds)
    })
  }


  const sendToast = (type = 'warn', message) => {
    if (type === 'success') {
        toast.success(message, {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
        });
    } else if (type === 'warn') {
        toast.warn(message, {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
        });
    }
};


  const enableInbound = async (residentId, contactId) => {

    // call enable inbound calling, until we get 200 / 201 
    // wait for exponential 
    // do this for 60


    let result = null;
    for (let i = 0; i < 8; i++) {
      const waitSeconds = 1000* (3**i);

      try {
        result = await enableInboundCalling(residentId, contactId);
        console.log('result:', result)
        setMakingCallsPercent(100);
        return true;
      } catch (err) {
        console.log('error:', err)
        await wait(waitSeconds);
        setMakingCallsPercent(((1+i)/8) * 100);
      }
    }

    // setMakingCallsPercent(100);

    return null;
    
  }
  const navigate = (to: string) => {
    toggleRedirect(to);
    return;
};

  const submitContact = async () => {
    console.log(contact);
    console.log(name);
    setMakingCalls(true);
    setMakingCallsPercent(0);

    try {
      const {contactId} = await createAddressBookContact(residentId, name, [contact]);
      setMakingCallsPercent(5);

      console.log('done saving contact', contactId);
      await wait(90*1000);
      const result = await enableInbound(residentId, contactId);

      if (result) {
        // Good toast
        setMakingCalls(false);
        sendToast('success', 'Inbound calling enabled');

        navigate(`/message-recipients/${residentId}/address-book/contacts/${contactId}`)

      } else {
        setMakingCalls(false);

        sendToast('warn', 'Failed to enable inbound calling, try after sometime');
        navigate(`/message-recipients/${residentId}/address-book/contacts/${contactId}`)
      }
      setMakingCalls(false);

    } catch (err) {
      console.log('err:', err);
      sendToast('warn', 'Failed to create and enable inbound calling, try after sometime');
      setMakingCalls(false);
      reload();
      close();

    }
  }
  return (
    <Modal open={isModalOpen} onClose={()=> {if (!makingCalls) {close()}}} size={'tiny'} className="invite-modal-root" closeIcon>
      <ModalHeader>
        <h5>
          Enter the phone number of alexa account for enabling inbound and outbound calling
        </h5>
      </ModalHeader>

      <Form onSubmit={submitContact} error>
        <Modal.Content className="fnf-invite-modal-content">
          <Dimmer active={loading} inverted>
            <Loader active={loading} />
          </Dimmer>

          <div className="name-section">
            <FormInput
            
            value={name}
            onChange={(e) => {
                setName(e.target.value);
            }}
            required
            name="FirstName"
            placeholder="First Name">

            </FormInput>
          </div>
          <ContactInput
            onChange={(e) => {
              setUsernameError('');
              setContact(e);
            }}
            error={usernameError || error}
          />

          {makingCalls && 
          <div>
          <Progress
            percent={makingCallsPercent}
            size="tiny"
            autoSuccess
            color="blue"
            className="inbound-progress"
            style={{ width: '30%', marginBottom: '0px' }}
          />
          <div>
            We are saving this contact and enabling inbound calls. This may take some time.
          </div>
          </div>
}

        </Modal.Content>

        <ModalActions className="inviteBtn">
                    <Button className="ui primary small button " type="submit" loading={makingCalls}>
                        Add Contact
                    </Button>
                </ModalActions>

      </Form>



    </Modal>






  )

}

export default AddContactModal